module.exports = __webpack_public_path__ + "img/welcome-2-uae.3dcd7104.png";